import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { NavContext } from "@/components/landing/NavContext";
import { Navbar } from "@/components/landing/Navbar";
import { FooterBar } from "@/components/landing/FooterBar";
import { Hero } from "@/components/landing/Hero";
import { Pagos } from "@/components/landing/Pagos";
import { Automatizacion } from "@/components/landing/Automatizacion";
import { Flow } from "@/components/landing/Flow";
import { Conservatorio } from "@/components/landing/Conservatorio";
import { RWA } from "@/components/landing/RWA";
import { Multifirma } from "@/components/landing/Multifirma";
import { Explorer } from "@/components/landing/Explorer";
import { Waitlist } from "@/components/landing/Waitlist";

const SECTIONS = {
  inicio: Hero,
  pagos: Pagos,
  automatizacion: Automatizacion,
  experiencia: Flow,
  conservatorio: Conservatorio,
  activos: RWA,
  multifirma: Multifirma,
  seguridad: Explorer,
  acceso: Waitlist,
};

const EASE = [0.16, 1, 0.3, 1];

function App() {
  const [active, setActive] = useState("inicio");

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  const navigate = (id) => {
    if (SECTIONS[id] && id !== active) {
      setActive(id);
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  };

  const ActiveSection = SECTIONS[active];

  return (
    <NavContext.Provider value={navigate}>
      <div className="App min-h-screen bg-canvas">
        <div className="grain-overlay" />
        <Toaster position="top-center" richColors />
        <Navbar active={active} onNavigate={navigate} />

        <AnimatePresence mode="wait">
          <motion.main
            key={active}
            initial={{ opacity: 0, x: 48 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -48 }}
            transition={{ duration: 0.5, ease: EASE }}
          >
            <ActiveSection />
          </motion.main>
        </AnimatePresence>

        <FooterBar />
      </div>
    </NavContext.Provider>
  );
}

export default App;

